import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"
import ItemService from "../../../services/commonService";

export const fetchMasterList = createAsyncThunk("getMasterListData", async(value,searchValue) => {
        const {name} = value
        const res = await ItemService.getMasterListData(value);
        res.name=name;
        return res
})

export const searchMasterList = createAsyncThunk("searchMasterListData", async(searchValue) => {
        const searchResult = await ItemService.searchMasterListData(searchValue);
        searchResult.name = searchValue.name;
        return searchResult
})

export const fetchMasterListById = createAsyncThunk("getMasterListDataById", async(param) => {
    const {page} = param
    const res = await ItemService.getMasterListDataById(param);
    res.name=page;
    return res
})

export const fetchActiveMasterListById = createAsyncThunk("getActiveMasterListDataById", async(param) => {
    const {page} = param
    const res = await ItemService.getActiveMasterListDataById(param);
    res.name=page;
    return res
})

export const addMasterRecord = createAsyncThunk("addMasterRecord", async(value) => {
    let res 
    if(!value.edit){
        res = await ItemService.addMasterData(value);
    } else {
        res = await ItemService.updateMasterData(value);
    }  
    return res
})

export const deleteMasterRecord = createAsyncThunk("deleteMasterData", async(value) => {
    const res = await ItemService.deleteMasterData(value);
    return res
})

const getMasterListData = createSlice({
    name:"commonMasterList",
    initialState: {
        isLoading:false,
        page:{},
        isError:false,
    },
    reducers: {
       
    },
    extraReducers:(builder) => {
        builder.addCase(fetchMasterList.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(fetchMasterList.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.page[payload.name]=payload
            state.isError=false
        })
        builder.addCase(searchMasterList.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(searchMasterList.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.page[payload.name]=payload
            state.isError=false
        })
        builder.addCase(fetchMasterListById.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(fetchMasterListById.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.page[payload.name]=payload
            state.isError=false
        })
        builder.addCase(addMasterRecord.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(addMasterRecord.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.isError=false;
        })
        builder.addCase(deleteMasterRecord.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(deleteMasterRecord.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.isError=false;
        })
    }
})

export default getMasterListData.reducer;
